import React from "react";
import "../Styles/Footer.css";

function Footer() {
    return (
        // Footer
        <section id="footer">
            <div className="container">
                <div className="col-12">
                    <ul className="copyright">
                        <li>Made with 💖 by Emily Brockett</li>
                    </ul>
                </div>
            </div>
        </section>
    );
}

export default Footer;
